import { Eole } from "@syadem/eole";
import { parseEoleEvent } from "../domain/parseEoleEvent";
import { Appointment } from "../domain/appointment";
import { AppStore } from "../store";

export class GetCitizenCalendarQuery {
  constructor(
    private readonly eole: Eole,
    private readonly store: AppStore,
  ) {}

  async call(id: string): Promise<Appointment[]> {
    return this.eole
      .getFullCitizenCalendar(id)
      .then((calendar) => {
        const parsedCalendar = calendar.map(parseEoleEvent);

        this.store.setState((state) => ({
          appointments: {
            ...state.appointments,
            [id]: parsedCalendar,
          },
        }));

        return parsedCalendar;
      })
      .catch((e) => {
        console.error(e);
        return [];
      });
  }
}
